import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.167 14.517H9.075c-1.367 0-2.475-1.15-2.475-2.567a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625c0 .725.55 1.317 1.225 1.317h2.092c.542 0 .992-.484.992-1.067 0-.725-.259-.867-.684-1.017L8.117 10c-.65-.225-1.525-.708-1.525-2.2 0-1.283 1.008-2.317 2.241-2.317h2.092c1.367 0 2.475 1.15 2.475 2.567a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625c0-.725-.55-1.317-1.225-1.317H8.833c-.541 0-.991.484-.991 1.067 0 .725.258.867.683 1.017L11.883 10c.65.225 1.526.708 1.526 2.2-.009 1.275-1.009 2.317-2.242 2.317"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 15.625A.63.63 0 0 1 9.375 15V5A.63.63 0 0 1 10 4.375a.63.63 0 0 1 .625.625v10a.63.63 0 0 1-.625.625"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 18.958c-4.941 0-8.958-4.016-8.958-8.958S5.059 1.042 10 1.042c4.942 0 8.959 4.016 8.959 8.958S14.942 18.958 10 18.958m0-16.666C5.75 2.291 2.292 5.75 2.292 10S5.75 17.708 10 17.708 17.71 14.25 17.71 10 14.25 2.292 10 2.292"
    }, null, -1)
  ]))]))
}
export default { render: render }